import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const FooterInfoService = {
  getList: async ({ isActive, isAddress, isTextOnly }) => {
    const params = new URLSearchParams({
      ...(isActive && { isActive }),
      ...(isAddress && { isAddress }),
      ...(isTextOnly && { isTextOnly }),
    });
    const response = await apiService.get(
      `/footer-info-section?${params.toString()}`
    );
    console.log(response);
    return response.data;
  },

  create: async (data) => {
    const response = await apiService.post("/footer-info-section", data);
    return response.data;
  },

  update: async (id, updatedData) => {
    const response = await apiService.put(
      `/footer-info-section/${id}`,
      updatedData
    );
    return response.data;
  },

  getbyId: async (id) => {
    const response = await apiService.get(`/footer-info-section/${id}`);
    console.log("called", response);
    console.log("called", response.data);
    return response.data;
  },
  delete: async (id) => {
    console.log(id);
    const response = await apiService.delete(`/footer-info-section/${id}`);
    console.log("called", response);
    return response.data;
  },
};
export default FooterInfoService;
